<template>
  <v-container>
    <div v-if="cardView">
      <v-row justify="space-between" >
        <v-col md="4">
          <v-select
            :items="itemsPerPageLabels"
            v-model="options.itemsPerPage"
            :label="$t('components:common.elements-per-page')"/>
        </v-col>
        <v-col md="4" lg="3">
          <v-btn
            color="primary"
            elevation="0"
            outlined
            v-if="!facilityId && !isFinish"
            @click="addDocumentation()"
          > {{ $t('buttons:add-specific', {specific: $t('book/issue:taskDocumentation')}) }}</v-btn>
        </v-col>
      </v-row>
      <v-row justify="start">
        <v-col md="3" v-for="document in this.documents" :key="document.id">
          <DocumentItem
            @itemClicked="(v) => openDocumentation(v)"
            :document="document"
          />
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col>
          <v-pagination
            v-model="options.page"
            :length="options.totalPages"
            :total-visible="7"
          ></v-pagination>
        </v-col>
      </v-row>
    </div>
    <div v-if="!cardView">
      <DataTablePaginated
          ref="table"
          class="ma-1"
          :headers="headers"
          icon="visibility"
          :iconTooltip="$t('buttons:edit')"
          :addBtnText="$t('buttons:add-specific', {specific: $t('book/issue:invoiceDocumentation')})"
          @clickedButton1="v => openDocumentation(v)"
          @updateTableData="loadByFacility"
          :addBtn="true"
          sort-by="id"
          :sortDesc="true"
      />
    </div>
    <div>
      <TaskDocumentationDialog
          @closeDialog="closeDialog"
          ref="taskDocumentation"
          :facility-mode="facilityMode"
      />
    </div>
  </v-container>
</template>
<script>

import TaskDocumentationService from '@/modules/book/services/task-documentation/task-documentation-service';
import TaskDocumentationDialog from '@/modules/book/views/task/components/TaskDocumentationDialog';
import DocumentItem from '@/modules/book/views/task/components/DocumentItem';
import DataTablePaginated from "@/modules/core/components/DataTable/DataTablePaginated.vue";

export default {
  name: 'DocumentTab',
  components: {DataTablePaginated, TaskDocumentationDialog, DocumentItem},
  props: {
    taskInfo: {},
    facilityId: String,
    facilityMode: Boolean,
    cardView: Boolean
  },
  data() {
    return {
      page: 1,
      search: '',
      documents: [],
      itemsPerPage: 5,
      options: {
        sortBy: ['name'],
        sortDesc: [false],
        itemsPerPage: 4,
        page: 1,
        totalPages: 0
      },
      itemsPerPageLabels: [
        {value: 4, text: 4},
        {value: 8, text: 8},
        {value: 12, text: 12}
      ]
    }
  },
  computed: {
    headers() {
      return [
        { text: this.$t('book/issue:common.supplier'), value: 'supplier', default: true, sortable:false },
        { text: this.$t('common:valid-from'), value: 'startDate', default: true, sortable:false },
        { text: "", value: "controls", sortable: false, align: 'end' }
      ];
    },
    isFinish() {
      return this.taskInfo && this.taskInfo.finish;
    }
  },
  watch: {
    options: {
      deep: true,
      handler() {
        if (this.cardView)
          this.loadDocuments();
      }
    },
    taskInfo() {
      this.loadDocuments();
    },
    cardView() {
      if (!this.cardView) {
        this.$refs.table.callTableUpdate();
      } else {
        this.loadDocuments();
      }
    }
  },
  methods: {
    loadDocuments() {
      if ((!this.taskInfo || !this.taskInfo.id) && (!this.facilityId || this.facilityId.length === 0)) return;

      if (this.taskInfo) {
        this.loadByTask();
      } else {
        this.loadByFacility();
      }
    },
    closeDialog() {
      this.loadDocuments();
      this.$emit('updateData');
    },
    clearData() {
      this.page = 1;
      this.search = '';
      this.documents = [];
      this.itemsPerPage = 5;
    },
    openDocumentation(document) {
      this.$refs.taskDocumentation.openDialog(document);
    },
    addDocumentation() {
      this.$refs.taskDocumentation.openCreationDialog(this.taskInfo);
    },
    loadByTask() {
      TaskDocumentationService.readAllPaginatedByTaskIdFromAPI(
        this.taskInfo.id,
        this.options.page - 1,
        this.options.itemsPerPage,
        '',
        this.options.sortBy,
        this.options.sortDesc,
        (response) => {
          let data = response.data;
          this.options.totalPages = data.totalPages;
          this.documents = data.content;
        },
        () => {
        }
      );
    },
    loadByFacility(options, search) {

      TaskDocumentationService.readAllPaginatedByFacilityIdFromAPI(
        this.facilityId,
        options ? options.page - 1 : this.options.page - 1,
          options ? options.itemsPerPage : this.options.itemsPerPage,
          search ? search : '',
        options ? options.sortBy : this.options.sortBy,
        options ? options.sortDesc : this.options.sortDesc,
        (response) => {
          let data = response.data;
          this.options.totalPages = data.totalPages;
          this.documents = data.content;

          if (!this.cardView) {
            this.$refs.table.fillTableData(response.data);
          }
        },
        () => {
          if (!this.cardView) {
            this.$refs.table.loading = false;
          }
        }
      );
    }
  },
  created() {
    this.loadDocuments();
  }
}
</script>